import { Dialog, Portal } from '@chakra-ui/react';
import * as React from 'react';

export const DialogRoot = Dialog.Root;
export const DialogBackdrop = Dialog.Backdrop;
export const DialogHeader = Dialog.Header;
export const DialogTitle = Dialog.Title;
export const DialogBody = Dialog.Body;
export const DialogFooter = Dialog.Footer;

interface DialogContentProps extends React.ComponentProps<typeof Dialog.Content> {
  /** Render into a React Portal (defaults to true, matching Chakra's recipe). */
  portalled?: boolean;
  portalRef?: React.RefObject<HTMLElement>;
}

// Chakra v3's Dialog.Content must live inside a Dialog.Positioner to be
// centered/stacked above the backdrop. The previous version of this wrapper
// re-exported Dialog.Content directly, so every dialog built on top of it
// (Admin > Generate API Key, User edit, Policy upload, etc.) rendered the
// backdrop but never positioned the content — it stayed behind the backdrop,
// making the dialog look like the screen "just grays out".
export const DialogContent = React.forwardRef<HTMLDivElement, DialogContentProps>(
  function DialogContent(props, ref) {
    const { children, portalled = true, portalRef, ...rest } = props;
    return (
      <Portal disabled={!portalled} container={portalRef}>
        <Dialog.Positioner>
          <Dialog.Content ref={ref} {...rest}>
            {children}
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    );
  }
);
export const DialogCloseTrigger = Dialog.CloseTrigger;
